import {ENV} from '@/constants/EnvConstants';

export const apiBaseSplitBills = {
  baseUrl: ENV.VITE_APIS_AI_BASE_DOMAIN_URL,
  endpoints: {
    createSplitBill: '/split',
    split: '/split/:splitId',
    saveParticipantPhone: '/split/:splitId/participants',
    validateParticipantOtp:
      '/split/:splitId/split-participants/:participantId/validate',
    confirmPayment:
      '/split/:splitId/split-participants/:participantId/confirm-payment',
    resendParticipantOtp:
      '/split/:splitId/split-participants/:participantId/resend-otp',
    joinLoggedUserToSplit: '/split/:splitId/participants/join-auth',
  },
};
